import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";

import { fetchUserAttributes } from "aws-amplify/auth";


import LeftTextArea from "./LeftTextArea";
import RightTextArea from "./RightTextArea";
import LanguageDropdown from "./LanguageDropdown";
import { toTitleCase } from "./Utils";
import { languagesFromData, languagesToData } from "./Variables";
// import {submitTextTranslation} from "./ApiCalls"

import { post } from "aws-amplify/api";

// Custom hook for debouncing
function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

function TextTranslate(props) {
  const [translateFromLanguag, setTranslateFromLanguag] = useState("");
  const [translateToLanguag, setTranslateToLanguag] = useState("");

  const [translateToLanguageList, setTranslateToLanguageList] = useState([]);

  const [enteredText, setEnteredText] = useState("");
  const [fetchedText, setFetchedText] = useState("");

  const [requestId, setRequestId] = useState("");

  const [userEmailAddress, setUserEmailAddress] = useState("");
  const [userOrg, setUserOrg] = useState("");

  // Debounce enteredText
  const debouncedEnteredText = useDebounce(enteredText, 2000);

  function languagesToFilterFunction() {
    var sliceToReturn = [];
    var availableToLanguageIds = [];
    // Pick TO languages from
    languagesFromData.forEach(function (valueFrom) {
      // Search the active from and get its data
      if (valueFrom.id === translateFromLanguag) {
        // Get availableto data
        availableToLanguageIds = valueFrom.availableto;
      }
    });

    //
    languagesToData.forEach(function (valueFrom) {
      if (availableToLanguageIds.includes(valueFrom.id)) {
        sliceToReturn.push(valueFrom);
      }
    });
    setTranslateToLanguageList(sliceToReturn);
  }

  // When from language changes adapt To languages
  useEffect(() => {
    // Reset selected to language
    setTranslateToLanguag("");
    // Execute filtering and TO language array set
    languagesToFilterFunction();
  }, [translateFromLanguag]);

  useEffect(() => {
    if (enteredText === "") {
      setFetchedText("");
      setRequestId("")
    }
  }, [enteredText]);

  useEffect(() => {
    if (debouncedEnteredText) {

      if (translateFromLanguag !== "" && translateToLanguag !== ""){

        submitTextTranslation(translateFromLanguag, translateToLanguag, debouncedEnteredText, userEmailAddress, userOrg);
      }
      
    }
  }, [debouncedEnteredText, translateFromLanguag, translateToLanguag]);

  useEffect(() => {
    // Get user attributes
    handleFetchUserAttributes();
  }, []);

  async function handleFetchUserAttributes() {
    try {
      const userAttributes = await fetchUserAttributes();
      setUserEmailAddress(userAttributes.email);
      if (userAttributes.zoneinfo && userAttributes.zoneinfo !== "") {
        setUserOrg(toTitleCase(userAttributes.zoneinfo));
      }else{
        setUserOrg("vicomtech");
      }
    } catch (error) {
      // console.log(error);
      // TODO logout
    }
  }

  async function submitTextTranslation(languageFrom, languageTo, translationText, user, org) {
    try {
      const textTranslationRequest = { from: languageFrom, to: languageTo, user: user, workgroup: org, text: translationText };
      /*
      	FromLanguage    string `json:"from"`
        ToLanguage      string `json:"to"`
        TranslationText string `json:"text"`
        Workgroup       string `json:"workgroup"`
        UserEmail       string `json:"user"`
      */

      const restOperation = post({
        apiName: "probatuaeusapi",
        path: "/v1/api/translationtxt",
        options: {
          body: textTranslationRequest,
        },
      });

      const { statusCode, body } = await restOperation.response;
      const bodyJson = await body.json();
      if (statusCode === 200 && bodyJson.success){
        // Set response text
        setFetchedText(bodyJson.message)
        setRequestId(bodyJson.id)
      }else{
        // Set response text as error message
        setFetchedText(bodyJson.attention)
        setRequestId(bodyJson.id)
      }


    } catch (err) {
      // Set response text
      setFetchedText("")
      setRequestId("")
    }
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "start",
        flexDirection: { xs: "column", md: "row" },
        m: "1rem",
      }}
    >
      <Box sx={{ flex: 1 }}>
        <LanguageDropdown currentLanguage={translateFromLanguag} setLanguage={setTranslateFromLanguag} languages={languagesFromData} />
        <LeftTextArea enteredText={enteredText} setEnteredText={setEnteredText} />
      </Box>
      <Box sx={{ flex: 1 }}>
        <LanguageDropdown currentLanguage={translateToLanguag} setLanguage={setTranslateToLanguag} languages={translateToLanguageList} />
        <RightTextArea fetchedText={fetchedText} setFetchedText={setFetchedText} requestIdValue={requestId} workgroupValue={userOrg}/>
      </Box>
    </Box>
  );
}

export default TextTranslate;
